import { NavSection } from '../interfaces/ui/nav-item.interface';
import { PERMISSION_CODES } from './permission-codes.constants';

export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'General',
    items: [
      {
        label: 'Dashboard',
        icon: 'fa-solid fa-gauge',
        route: '/dashboard',
        permission: PERMISSION_CODES.metricas.view,
      },
    ],
  },
  {
    label: 'Captación',
    items: [
      {
        label: 'Campañas',
        icon: 'fa-solid fa-bullhorn',
        route: '/campaigns',
        permission: PERMISSION_CODES.campanas.view,
      },
      {
        label: 'Tags',
        icon: 'fa-solid fa-tag',
        route: '/tags',
        permission: PERMISSION_CODES.tags.view,
      },
      {
        label: 'Landings',
        icon: 'fa-solid fa-file-lines',
        route: '/landings',
        permission: PERMISSION_CODES.landings.view,
      },
    ],
  },
  {
    label: 'Predictor',
    items: [
      {
        label: 'Predictores',
        icon: 'fa-solid fa-trophy',
        route: '/predictors',
        permission: PERMISSION_CODES.predictores.view,
      },
      {
        label: 'Registros',
        icon: 'fa-solid fa-list-check',
        route: '/registrations',
        permission: PERMISSION_CODES.registros.view,
      },
      {
        label: 'Pronósticos',
        icon: 'fa-solid fa-square-poll-vertical',
        route: '/submissions',
        permission: PERMISSION_CODES.pronosticos.view,
      },
    ],
  },
  {
    label: 'Comunidad',
    items: [
      {
        label: 'Jugadores',
        icon: 'fa-solid fa-users',
        route: '/players',
        permission: PERMISSION_CODES.jugadores.view,
      },
      {
        label: 'Recompensas',
        icon: 'fa-solid fa-gift',
        route: '/rewards',
        permission: PERMISSION_CODES.premios.view,
      },
      {
        label: 'Catálogo',
        icon: 'fa-solid fa-store',
        route: '/catalog',
        permissions: [
          PERMISSION_CODES.catalogos.view,
          PERMISSION_CODES.canjes.view,
        ],
      },
      {
        label: 'Bonos',
        icon: 'fa-solid fa-coins',
        route: '/bonos',
        permission: PERMISSION_CODES.bonos.view,
      },
    ],
  },
  {
    label: 'Sistema',
    items: [
      {
        label: 'Usuarios',
        icon: 'fa-solid fa-user-gear',
        route: '/users',
        permission: PERMISSION_CODES.usuarios.view,
      },
      {
        label: 'Auditoría',
        icon: 'fa-solid fa-shield-halved',
        route: '/audit-logs',
        permission: PERMISSION_CODES.auditoria.view,
      },
      {
        label: 'Roles y Permisos',
        icon: 'fa-solid fa-user-shield',
        route: '/roles',
        permission: PERMISSION_CODES.roles.view,
      },
      {
        label: 'Widget',
        icon: 'fa-solid fa-sliders',
        route: '/widget-config',
        permission: PERMISSION_CODES.widget.view,
      },
      {
        label: 'Configuraciones',
        icon: 'fa-solid fa-gear',
        route: '/settings',
        permission: PERMISSION_CODES.sistema.view,
      },
    ],
  },
];
